(() => {
  const fitHeadings = () => {
    document.querySelectorAll('#content h1, #content h2, #content h3').forEach((heading) => {
      if (heading.closest('.academy-layered, .siti-professional-join, .siti-pdp, .siti-tech')) return;
      heading.style.fontSize = '';
      heading.style.whiteSpace = '';
      if (heading.matches('.siti-discipline h1')) return;
      if (heading.closest('.siti-knowledge__card')) return;
      if (window.innerWidth > 599 || heading.clientWidth < 100) return;
      if (heading.textContent.trim().split(/\s+/).length > 6) return;

      heading.style.whiteSpace = 'nowrap';
      let size = parseFloat(getComputedStyle(heading).fontSize);
      while (heading.scrollWidth > heading.clientWidth + 1 && size > 16) {
        size -= 1;
        heading.style.fontSize = `${size}px`;
      }
      if (heading.scrollWidth > heading.clientWidth + 1) heading.style.whiteSpace = '';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fitHeadings, { once: true });
  } else {
    fitHeadings();
  }
  document.fonts?.ready.then(fitHeadings);
  window.addEventListener('load', fitHeadings);
  window.addEventListener('resize', fitHeadings);
})();
